export const BOT_CONFIG = {
    // Delays (ms)
    INITIAL_START_DELAY: 5000,      // 5s antes de começar (aparece digitando)
    INITIAL_TYPING_DURATION: 10000, // 10s digitando na primeira mensagem
    NORMAL_TYPING_DELAY: 10000,     // 10s digitando nas próximas interações

    MAX_INTERACTIONS: 3,    // Limite de interações

    // Textos Globais
    GLOBAL_SCRIPTS: {
        HANDOFF_COMPLETE: "Obrigado pelas informações. Seu ticket foi validado e encaminhado para a equipe responsável. Aguarde o atendimento.",
        FINALIZACAO_PADRAO: "Atendimento transferido para a equipe de suporte. Um de nossos agentes irá te atender em breve.",
    },

    // Configurações por Categoria
    CATEGORIES: {
        // 1. DENÚNCIA DE JOGADOR
        'denuncia_jogador': {
            aliases: ['denuncia'],
            mandatoryFields: [
                { key: 'evidenceUrl', label: 'Link do Vídeo/Prova', type: 'url' }
            ],
            scripts: {
                GREETING_MISSING: (name) =>
                    `Opa!\n\n` +
                    `Recebi sua Denúncia, mas ainda não consigo encaminhar para a moderação porque faltam algumas informações essenciais.\n` +
                    `No momento, apenas casos com (LINK) do corrido são analisados. Sem esses itens, a moderação não consegue confirmar o ocorrido nem identificar corretamente os envolvidos, então seu ticket ficará travado na triagem.\n\n` +
                    `Para que eu possa liberar seu caso para nossa equipe de moderadores, por favor envie o link do YouTube na minutagem do corrido.\n\n` +
                    `Exemplo: https://www.youtube.com/watch?xxxxxxxxxxxxxxx Minuto: 2:40\n\n` +
                    `Se não souber enviar para o YouTube:\n\n` +
                    `Faça login no YouTube\n` +
                    `No canto direito na parte de cima, clique em CRIAR (é uma seta apontando para cima) e depois Enviar vídeos .\n` +
                    `Lá em cima em (Visibilidade) seleciona a opção: Não listado\n` +
                    `Copie o URL do vídeo e envie aqui.\n\n` +
                    `Assim que eu receber as informações completas, eu valido e encaminho com a prioridade correta.\n\n` +
                    `Obrigado,\n` +
                    `Tronos - Em nome do Grupo Capital`,

                GREETING_OK: (name) =>
                    `Olá, recebi sua Denúncia de Jogador e está tudo certo com as informações enviadas aparentemente.\n\n` +
                    `Eu validei a prova e os dados do ocorrido e o ticket já está pronto para seguir para a moderação sem pendências.\n\n` +
                    `Com isso, vou encaminhar agora para a equipe responsável com a prioridade adequada ao tipo de ocorrência.\n\n` +
                    `A partir daqui, um moderador vai analisar o material, confirmar o contexto e tomar as medidas cabíveis; se durante a análise for necessário complementar algum detalhe (por exemplo, trecho anterior/posterior do vídeo, minutagem, ID pouco legível ou outro ângulo), o pedido será feito aqui no próprio ticket.\n\n` +
                    `Por enquanto, você não precisa fazer mais nada — seu caso está validado, encaminhado e você será atualizado por esta conversa quando houver andamento.\n\n` +
                    `Obrigado,\n` +
                    `Tronos - Em nome do Grupo Capital`,
            }
        },

        // 2. PROBLEMA COM COMPRAS
        'compras_doacoes': {
            aliases: ['compras'],
            mandatoryFields: [
                { key: 'paymentProof', label: 'Comprovante/Dados da Compra', type: 'text' }
            ],
            scripts: {
                GREETING_MISSING: (name) =>
                    `Olá, recebi seu ticket em Problema com Compras, mas faltam informações para eu conseguir validar e encaminhar para a equipe de verificação.\n` +
                    `Para avançar, envie aqui no ticket: qual foi o produto/benefício comprado, data e horário aproximados, forma de pagamento, valor, ID do pedido/transação (ou print do comprovante) e para qual conta/personagem era a entrega\n` +
                    `Assim que você enviar, iremos validar e encaminhar para a equipe analisar os logs e resolver.\n\n` +
                    `Obrigado,\n` +
                    `Tronos - Em nome do Grupo Capital`,

                GREETING_OK: (name) =>
                    `Olá! Recebi sua solicitação em Problema com Compras e as informações estão completas para verificação.\n\n` +
                    `Já registrei os dados da compra e o que exatamente ocorreu. Com isso, vou encaminhar para a equipe responsável pela loja/sistema de entregas para conferirem o pagamento, a vinculação ao seu usuário/personagem e o log de entrega.\n` +
                    `Se for confirmado pagamento aprovado sem entrega, a equipe fará a regularização (entrega/ativação/correção) e registrará a atualização aqui no ticket; se houver divergência (pagamento pendente, chargeback, dados incompletos), vamos te pedir complemento por aqui.\n\n` +
                    `Obs: Agora se você quiser outra coisa, descreva aqui abaixo. Você não precisa abrir outro ticket; acompanhe este chamado para as próximas atualizações.\n` +
                    `Enviando para equipe agora.\n\n` +
                    `Obrigado,\n` +
                    `Tronos - Em nome do Grupo Capital`,
            }
        },

        // 3. PROBLEMA TÉCNICO / BUG
        'programacao': {
            aliases: ['tecnico', 'bug', 'bug_report'],
            mandatoryFields: [
                { key: 'evidenceUrl', label: 'Vídeo/Imagem do Problema', type: 'url' }
            ],
            scripts: {
                GREETING_MISSING: (name) =>
                    `Olá, recebemos o seu ticket com o assunto Problema Técnico / Bug, porém, faltam informações para conseguirmos validar e encaminhar para a equipe responsável.\n` +
                    `Para avançarmos, envie aqui no ticket uma prova com imagem (em formato .jpg, .png ou .webp) ou o envie o link de um vídeo do YouTube mostrando o problema técnico / bug, com o seguinte exemplo:\n` +
                    `Aqui um link do vídeo mostrando o bug: https://www.youtube.com/watch?xxxxxxxxxxxxxxx na minutagem 2:40.\n\n` +
                    `Se não souber enviar para o YouTube, siga os passos abaixo para saber como:\n` +
                    `Faça login no YouTube;\n` +
                    `No canto direito na parte de cima, clique em CRIAR (é uma seta apontando para cima) e depois Enviar vídeos;\n` +
                    `Lá em cima em (Visibilidade) seleciona a opção: Não listado;\n` +
                    `Copie o URL do vídeo e envie aqui.\n` +
                    `Assim que você enviar, iremos validar e encaminhar para a equipe analisar o problema, e iremos encaminhar com a prioridade correta.\n\n` +
                    `Obrigado,\n` +
                    `Tronos - Em nome do Grupo Capital`,

                GREETING_OK: (name) =>
                    `Olá! Recebi seu ticket com o assunto Problema Técnico / Bug e as informações estão completas para verificação.\n\n` +
                    `Já registrei os dados enviados e o que exatamente ocorreu e com isso, vou encaminhar para a equipe responsável para que o caso seja analisado.\n\n` +
                    `Obs: Agora se você quiser outra coisa, descreva aqui abaixo. Você não precisa abrir outro ticket. Acompanhe este chamado para as próximas atualizações.\n\n` +
                    `Obrigado,\n` +
                    `Tronos - Em nome do Grupo Capital`,
            }
        },

        // 4. CONTESTAR PUNIÇÃO (Revogar Punição)
        'contestar_punicao': {
            aliases: ['punicao', 'banimento'],
            mandatoryFields: [], // Todos são obrigatórios no formulário
            scripts: {
                GREETING_OK: (name) =>
                    `Olá! Recebi seu ticket referente à Revogação de Punição. As informações e justificativas enviadas estão completas para análise. Já registrei os dados e encaminhei para a equipe de coordenação revisar o seu caso. Peço que aguarde o parecer final neste chamado.\n\n` +
                    `Obrigado,\n` +
                    `Tronos - Em nome do Grupo Capital`,
            }
        },

        // 5. DENÚNCIA STAFF
        'denuncia_staff': {
            aliases: ['staff'],
            mandatoryFields: [
                { key: 'evidenceUrl', label: 'Prova do Ocorrido', type: 'url' }
            ],
            scripts: {
                GREETING_MISSING: (name) =>
                    `Olá, recebemos sua Denúncia Contra Staff, porém, para que possamos tomar qualquer medida, precisamos de provas concretas (vídeos sem edições ou prints claros do ocorrido). Por favor, envie o link do vídeo ou a imagem que comprove a conduta irregular mencionada. Denúncias sem provas não podem ser processadas pela equipe de supervisão.\n` +
                    `Envie aqui no ticket prova(s) (em formato de imagem .jpg, .png ou .webp) ou o envie o link de um vídeo do YouTube mostrando a má conduta do staff em questão, com o seguinte exemplo:\n` +
                    `Aqui um link do vídeo mostrando a má conduta de um staff: https://www.youtube.com/watch?xxxxxxxxxxxxxxx na minutagem 2:40.\n\n` +
                    `Se não souber enviar para o YouTube, siga os passos abaixo para saber como:\n` +
                    `Faça login no YouTube;\n` +
                    `No canto direito na parte de cima, clique em CRIAR (é uma seta apontando para cima) e depois Enviar vídeos;\n` +
                    `Lá em cima em (Visibilidade) seleciona a opção: Não listado;\n` +
                    `Copie o URL do vídeo e envie aqui.\n\n` +
                    `Obrigado,\n` +
                    `Tronos - Em nome do Grupo Capital`,

                GREETING_OK: (name) =>
                    `Olá! Recebi sua Denúncia Contra Staff. As informações, provas e relatos enviados estão completos. Este caso é tratado com prioridade e já foi encaminhado diretamente à Gerência/Administração para uma investigação interna. Acompanhe as atualizações por aqui.\n\n` +
                    `Obrigado,\n` +
                    `Tronos - Em nome do Grupo Capital`,
            }
        },

        // 6. DÚVIDAS GERAIS
        'suporte_duvidas': {
            aliases: ['duvidas'],
            mandatoryFields: [], // Todos são obrigatórios
            scripts: {
                GREETING_OK: (name) =>
                    `Olá! Recebi sua dúvida e as informações fornecidas são suficientes para o esclarecimento. Já registrei sua pergunta e em breve um membro da equipe responderá detalhadamente para te auxiliar. Fique atento às notificações deste ticket.\n\n` +
                    `Obrigado,\n` +
                    `Tronos - Em nome do Grupo Capital`,
            }
        },

        // 7. CUPOM
        'cupons_descontos': {
            aliases: ['cupom'],
            mandatoryFields: [], // Todos são obrigatórios
            scripts: {
                GREETING_OK: (name) =>
                    `Olá! Recebi seu ticket sobre Cupom de Desconto. As informações sobre o erro ou a solicitação estão completas. Encaminhei o caso para o setor financeiro/comercial verificar a validade do cupom ou solucionar o problema da melhor maneira. Retornaremos com uma resposta em breve.\n\n` +
                    `Obrigado,\n` +
                    `Tronos - Em nome do Grupo Capital`,
            }
        },

        // 8. SUPER CUPOM (Bot Interativo de 4 Passos)
        'super_cupom': {
            aliases: ['superior_cupom'],
            isInteractive: true,
            scripts: {
                // Passo 1: Saudação e Opções Iniciais
                GREETING_OK: (name) =>
                    `Oi, tudo bem? 🙌\n\n` +
                    `Você quer um cupom com desconto né? Então deixa eu te contar como ele funciona!\n\n` +
                    `Esse cupom é exclusivo e não fica liberado por muito tempo, ele é individual e fica disponível por tempo limitado⏳. Quando gerado ele é aplicado no site automaticamente e fica aplicado para você.\n\n` +
                    `Ao clicar em “Gerar Acesso Exclusivo”, o sistema cria um código vinculado ao seu personagem 🎟️. Por isso, recomendamos que você clique somente quando já estiver pronto(a) para finalizar a compra.\n\n` +
                    `Assim, você evita que o código expire antes de concluir o pagamento ⚠️.\n\n` +
                    `Quando estiver tudo certo do seu lado, é só clicar no botão abaixo para gerar o seu cupom de acesso. 🚀\n\n` +
                    `[[GERAR ACESSO EXCLUSIVO|Estou pronto! Pode liberar o acesso. #AcessoLiberar]]`,

                // Passo 2: Acesso Liberado
                ACCESS_GRANTED: () =>
                    `Perfeito! Estou gerando seu código exclusivo agora.\n\n` +
                    `SEU CÓDIGO DO SUPER CUPOM É:\n\n` +
                    `> Ao clicar no botão, comprar agora: informe o código e faça a compra.\n\n` +
                    `[[COMPRAR AGORA|sc_abrir_checkout]]`,

                // Passo 3: Pesquisa pós-fechamento
                CHECKOUT_SURVEY: () =>
                    `Deu tudo certo por aí? 🙌 Se sim, você pode encerrar esse caso.\n\n` +
                    `[[ENCERRAR TICKET - OBRIGADO|Tudo certo! Recebi meu acesso. #CompraConcluida]]\n\n` +
                    `Caso tenha fechado a janela do site sem querer, você pode clicar em comprar agora novamente:\n\n` +
                    `[[COMPRAR AGORA|sc_abrir_checkout]]\n\n` +
                    `Agora se você tem dúvidas, pode chamar nossa equipe:\n\n` +
                    `[[PRECISO DE AJUDA - CHAMAR STAFF|Preciso de ajuda humana. #FalarComAtendente]]`,

                // Passo 4a: Compra Concluída
                CONCLUIDO: () =>
                    `Obrigado pela compra! Na maioria dos casos, entregamos na hora.\n\n` +
                    `Se for um pedido especial que você foi alertado em entrar em contato com a equipe, clique em [Falar com atendente]\n\n` +
                    `Se precisar de qualquer ajuda com o pedido, entrega ou tiver qualquer dúvida, é só me chamar abrir um ticket na categorias compras.\n\n` +
                    `[[FALAR COM ATENDENTE|Preciso de ajuda humana. #FalarComAtendente]]`,

                // Passo 4b: Desistência
                DESISTIR: () =>
                    `Beleza então! Vou estar encerrando esse caso. Quando estiver pronto, só abrir novamente um novo ticket.`,

                // Transbordo Staff
                TRANSFER_STAFF: () =>
                    `Ok, Vou chamar alguém da equipe, sem problema😊\n\n` +
                    `Vou encaminhar seu atendimento para uma atendente agora mesmo.\n\n` +
                    `Ela vai assumir essa conversa e te ajudar da melhor forma possível. Pode levar alguns instantes, mas você já está na fila de atendimento.\n\n` +
                    `Para adiantar, já explica qual é sua dúvida.\n\n` +
                    `Fica tranquilo(a), já já alguém fala com você por aqui.`,

                // Tempos de Inatividade
                STEP1_INACTIVITY_WARNING: () =>
                    `👋 Percebi que você ainda não gerou seu acesso exclusivo.\n\n` +
                    `O cupom é individual e fica disponível por tempo limitado.\n\n` +
                    `Caso não precise mais, vou encerrar esse ticket em 5 minutos. 😊\n\n` +
                    `[[FINALIZAR TICKET|Não preciso mais. #DesistirCompra]]`,

                STEP1_INACTIVITY_CLOSE: () =>
                    `🔒 Ticket encerrado por inatividade.\n\n` +
                    `Se ainda quiser seu acesso exclusivo (se ainda estiver disponível), é só abrir um novo ticket que te ajudamos novamente.`,

                STEP2_INACTIVITY_WARNING: () =>
                    `👀 Vi que você já recebeu seu código exclusivo.\n\n` +
                    `Lembrando que ele pode expirar se ficar muito tempo sem uso.\n\n` +
                    `Se já estiver pronto(a), clique em comprar agora para não perder o acesso.\n\n` +
                    `[[COMPRAR AGORA|sc_abrir_checkout]]\n\n` +
                    `Vou encerrar o ticket em breve, qualquer coisa você pode abrir outro.`,

                STEP3_INACTIVITY_CLOSE: () =>
                    `Obrigado! Por questão de organização, estou encerrando seu ticket.\n\n` +
                    `🔒 Ticket encerrado automaticamente por falta de confirmação.\n\n` +
                    `Se houver qualquer problema com sua compra, basta abrir um novo ticket que verificamos imediatamente.`
            }
        }
    }
};
